var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "16px",
    width: "16px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.231,182.605H443.96v-32.273c0-19.723-16.046-35.769-35.769-35.769h-32.273v-32.27 c0-19.788-16.053-35.769-35.767-35.769H35.769C16.095,46.525,0,62.455,0,82.293v211.332c0,19.723,16.046,35.769,35.769,35.769 H68.04v32.273c0,19.723,16.046,35.769,35.769,35.769h32.271v32.271c0,19.723,16.046,35.769,35.769,35.769h304.383 c19.723,0,35.769-16.046,35.769-35.769V218.373C512,198.651,495.954,182.605,476.231,182.605z M314.332,82.243L187.96,206.09 L61.591,82.246L314.332,82.243z M35.721,293.625l0.007-186.711l139.731,136.939c6.945,6.807,18.059,6.805,25.002,0l139.732-136.94 l-0.04,186.76L35.721,293.625z M103.761,361.665v-32.271h236.392c19.723,0,35.767-16.045,35.767-35.769V150.29l32.319,0.01 c0,0,0.001,0.011,0.001,0.033l-0.048,211.38L103.761,361.665z M476.231,429.753l-304.43-0.048v-32.271h236.392 c19.723,0,35.769-16.046,35.769-35.769V218.331l32.318,0.009c0,0,0.001,0.011,0.001,0.033L476.231,429.753z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsIcon);
export default __webpack_public_path__ + "static/media/emails-icon.a7978c0c663c5bbabbcde1a75ab11a78.svg";
export { ForwardRef as ReactComponent };